import React from 'react'
import PropTypes from 'prop-types'
import * as styles from './Caption.scss'

export default function Caption({ children }) {
  return <p className={styles.Caption}>{children}</p>
}

Caption.propTypes = {
  children: PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/components/Caption/index.js